export default function DisclosuresPage() {
  return (
    <div data-testid="page-disclosures" className="bg-[#F9F8F6]">
      <section className="max-w-4xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-24">
        <div className="text-xs uppercase tracking-[0.3em] text-[#8E6A2B] mb-6">— Compliance</div>
        <h1 className="font-serif text-5xl md:text-6xl text-[#0F292F] font-light tracking-tight leading-[1.05]">Disclosures & Licensure</h1>
        <p className="mt-6 text-sm text-[#52525B]">Last updated: December 2025</p>

        <div className="mt-12 space-y-10 text-[#1A1A1A] leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">Current Licensure & Services</h2>
            <p>
              The principal of H. Elliot Associates, LLC is a federally licensed Enrolled Agent
              (EA) authorized to practice before the U.S. Internal Revenue Service pursuant to
              Treasury Department Circular No. 230. Under this licensure, the firm provides:
            </p>
            <ul className="mt-4 space-y-2 list-disc pl-6">
              <li>Retirement planning (Roth conversions, RMDs, Social Security taxation, qualified-plan distributions, and the tax aspects of retirement decisions)</li>
              <li>Individual and small-business tax preparation</li>
              <li>Year-round tax planning</li>
              <li>IRS examination, collection, and appeals representation</li>
            </ul>
            <p className="mt-4">
              Retirement-related engagements focus on planning and the tax mechanics of
              retirement and do not include the recommendation, selection, or management
              of securities or investment portfolios.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">No Investment-Adviser Registration</h2>
            <p>
              H. Elliot Associates, LLC is <strong>not</strong> currently registered as an
              investment adviser with the United States Securities and Exchange Commission or
              with any state securities authority. The firm does <strong>not</strong> currently
              provide investment advisory services, manage client assets, or accept compensation
              for investment advice. The firm is not affiliated with any broker-dealer and does
              not effect securities transactions.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">Educational Content Only</h2>
            <p>
              Information presented on this website — including any reference to retirement,
              investment, estate, or other non-tax financial topics — is provided for general
              educational purposes only. Such content does not constitute investment, legal, or
              other personalized advice and should not be relied upon as a recommendation to
              buy, sell, or hold any security or to pursue any particular financial strategy.
              You should consult with appropriately licensed professionals regarding your
              individual circumstances.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">Tax Advice Disclosure</h2>
            <p>
              Tax-related discussions on this site or in client communications are general in
              nature unless tied to a specific engagement. Personalized tax advice is provided
              only under a written engagement letter. Tax laws change frequently; conclusions
              drawn at one time may not apply at another.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">Marketing & Communications</h2>
            <p>
              This website is intended as a communication with the public regarding the firm's
              tax services and pending credentials. The firm strives to ensure that all content
              is fair, balanced, and not misleading. If you believe any statement on this site
              is inaccurate, please contact the firm at the address below so that a correction
              may be reviewed and, if appropriate, made.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">Third-Party Links</h2>
            <p>
              Links to third-party websites are provided for convenience only. The firm does not
              endorse, approve, certify, or control these external sites and does not guarantee
              the accuracy of their content. Use of any third-party site is at the user's own risk.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl text-[#0F292F] mb-3">Contact for Compliance</h2>
            <p>
              For compliance-related inquiries or to report a concern about a statement made on
              this site, please write to helliotassociates@gmail.com or call (571) 598-5790.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
}
